// AIPage.jsx
import ServiceLayout from "../../components/ServiceLayout";
import ServiceFeatureCard from "../../components/ServiceFeatureCard";
import img1 from "../../assets/ai1.jpg";
import img2 from "../../assets/ai2.jpeg";
import img3 from "../../assets/ai3.jpg";
import img4 from "../../assets/ai4.jpg";
import img5 from "../../assets/ai5.webp";
import img6 from "../../assets/ai6.webp";
import bannerImg from "../../assets/ser2.jpg";
import overviewImg from "../../assets/ai.jpg";
import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function AIPage() {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const amount = 320; 
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  const capabilities = [
    {
      title: "Natural Language Understanding",
      description: "Build smart chatbots, text summarizers, and more with state-of-the-art NLP models.",
    },
    {
      title: "Computer Vision",
      description: "Enable object detection, facial recognition, and visual analysis with powerful CV pipelines.",
    },
    {
      title: "AI-Driven Automation",
      description: "Replace repetitive tasks with smart decision systems that adapt and learn over time.",
    },
    {
      title: "Model Deployment",
      description: "Deploy AI models in real-time environments with monitoring and retraining capabilities.",
    },
  ];

  const services = [
    {
      title: "Natural Language Processing",
      image: img4,
      description: "Extract insights from text, power chatbots, sentiment analysis, and automate language-based tasks.",
    },
    {
      title: "Computer Vision",
      image: img3,
      description: "Analyze and interpret images or video streams for tasks like detection, recognition, and tracking.",
    },
    {
      title: "AI Integration & Automation",
      image: img1,
      description: "Integrate AI into business workflows for smart automation and efficient operations.",
    },
    {
      title: "Model Deployment & Monitoring",
      image: img2,
      description: "Deploy ML models to production with performance tracking and real-time monitoring solutions.",
    },
    {
      title: "AI Chatbots & Assistants",
      image: img5,
      description: "Build conversational AI assistants for customer service, lead generation, and task automation.",
    },
    {
      title: "Fine-Tuning of Models",
      image: img6,
      description: "Adapt pre-trained AI models to your domain using fine-tuning techniques for maximum accuracy.",
    },
  ];

  return (
    <ServiceLayout
      title="AI & Machine Learning"
      bannerImg={bannerImg}
      overviewImg={overviewImg}
      overviewHeading="Harness the power of AI to unlock smarter business decisions."
      overviewText="From predictive modeling to intelligent automation, our AI solutions are designed to optimize operations and uncover opportunities."
      capabilities={capabilities}
      buttonText="Get a Custom AI Solution"
      servicesHeading="Our AI Services"
    >
      <div className="relative px-4 sm:px-6 pb-16">
        <div className="relative flex items-center">
          <button
            onClick={() => scroll("left")}
            className="hidden sm:block absolute left-4 z-10 bg-white border rounded-full p-2 shadow-md hover:bg-gray-100"
            style={{ top: "35%", transform: "translateY(-50%)" }}
          >
            <ChevronLeft size={40} />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scroll-smooth px-4 sm:px-12 scrollbar-hide w-full"
            style={{ scrollBehavior: "smooth" }}
          >
            {services.map((service, idx) => (
              <div
                key={idx}
                className="w-[300px] h-[250px] flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
              >
                <ServiceFeatureCard
                  title={service.title}
                  image={service.image}
                  description={service.description}
                  link="/contact"
                  className="h-full"
                />
              </div>
            ))}
          </div>

          <button
            onClick={() => scroll("right")}
            className="hidden sm:block absolute right-4 z-10 bg-white border rounded-full p-2 shadow-md hover:bg-gray-100"
            style={{ top: "35%", transform: "translateY(-50%)" }}
          >
            <ChevronRight size={40} />
          </button>
        </div>
      </div>
    </ServiceLayout>
  );
}
